// --------------------------------------------------------------
// Created On: 2026-03-20
// Author: Dimitra Weinstein
//
// Last Modified: 2026-04-10
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React from "react";
// import styles from "./SubsidiaryListRow.module.scss";

export default function SubsidiaryListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="subsidiary-list-row">
      <span>{props.companyName}</span>
    </div>
  );
}

interface Props {
  companyId: number;
  companyName: string;
}
